import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import h from '../../helpers/common';
import { useMpxFeed } from '../../hooks/data/useMpxFeed';
import { useConfigurationSections } from '../../hooks/useConfiguration';
import { useTvod } from '../../hooks/useTvod';
import { transformVOD } from '../../utils/vodTransformer';
import { GenericVodCarousel } from './GenericVodCarousel';

type TvodCarouselProps = {
    carousel: Carousel;
    data?: any;
};

const TVodCarousel = ({ carousel }: TvodCarouselProps) => {
    // Using React Query instead of Redux for configuration
    const { config } = useConfigurationSections();
    const { data, isLoading, error } = useMpxFeed(carousel);

    if (error) {
        return;
    }

    const content = data?.entries?.map((e) => transformVOD(e, config.promotionProviderImages)) ?? [];

    const { priceInfo, isTvod, expiryDate, isRented } = useTvod(content);

    const contentMappedWithTvod = content.map((item) => {
        const pricingInfo = priceInfo ?? {};
        const tVodStatusInfo = {
            isRented: isRented,
            expiryDate: expiryDate,
            isTvod,
        };

        return { ...item, meta: { ...item.meta, ...pricingInfo, ...tVodStatusInfo } };
    });

    return (
        <GenericVodCarousel
            isLoading={isLoading}
            id={carousel.id}
            name={carousel.id}
            params={{ items_count: contentMappedWithTvod.length, filter_params: '' }}
            data_stream={carousel.id}
            meta={{}}
            language={h.getLang()}
            title={carousel.title_resource_key}
            content={contentMappedWithTvod}
            carousel={carousel}
        />
    );
};

export { TVodCarousel };
